import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { IonImgCacheDirective } from './ion-img-cache.directive';
import { IonImgCacheService } from './ion-img-cache.service';

export {IonImgCacheService};

@NgModule({
  declarations: [
    IonImgCacheDirective
  ],
  providers: [
    IonImgCacheService
  ],
  exports: [
    IonImgCacheDirective
  ],
  imports: [
    BrowserModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class IonImgCache {}



// WEBPACK FOOTER //
// ./src/modules/ionic2-img-cache/ion-img-cache.ts